/**
 * MySQL/JSON columns often return images as a JSON string, not a real array.
 * Normalize to string[] for safe .map / [0] usage.
 */
export function parseImages(images) {
  if (!images) return [];
  if (Array.isArray(images)) return images.filter(Boolean);
  if (typeof images === "string") {
    const trimmed = images.trim();
    if (!trimmed) return [];
    try {
      const parsed = JSON.parse(trimmed);
      if (Array.isArray(parsed)) return parsed.filter(Boolean);
      if (typeof parsed === "string" && parsed) return [parsed];
    } catch {
      // plain URL
      return [trimmed];
    }
  }
  return [];
}
